// App constants
export const APP_NAME = 'WaifuDo'

// Content level labels
export const CONTENT_LEVEL_LABELS = {
  1: 'Suggestive',
  2: 'Spicy',
  3: 'Hot',
  4: 'Maximum'
} as const

export const CONTENT_LEVEL_DESCRIPTIONS = {
  1: 'Cute and modest outfits with light animations',
  2: 'Revealing outfits with noticeable bounce physics',
  3: 'Very revealing with exaggerated jiggle physics',
  4: 'Maximum spiciness - adults only'
} as const

// Gacha rates
export const GACHA_RATES = {
  common: 0.70,
  rare: 0.25,
  ultra_rare: 0.05
} as const

export const GACHA_COSTS = {
  single: 100,
  multi: 900 // 10% discount
} as const

export const GACHA_PITY_THRESHOLD = 50

// Pomodoro defaults
export const POMODORO_DEFAULTS = {
  workMinutes: 25,
  shortBreakMinutes: 5,
  longBreakMinutes: 15,
  sessionsBeforeLongBreak: 4
} as const

// Streak milestones for relationship progress
export const STREAK_MILESTONES = [
  { days: 7, reward: 'Special dialogue unlocked', type: 'dialogue' },
  { days: 14, reward: 'New pose unlocked', type: 'pose' },
  { days: 30, reward: 'Exclusive outfit unlocked', type: 'outfit' },
  { days: 60, reward: 'Special animation unlocked', type: 'animation' },
  { days: 100, reward: 'Max affection gallery art', type: 'gallery' }
] as const

// Affection thresholds
export const AFFECTION_LEVELS = {
  1: 0,
  2: 100,
  3: 300,
  4: 600,
  5: 1000
} as const

// Task categories with icons
export const TASK_CATEGORIES = [
  { id: 'work', label: 'Work', icon: '💼' },
  { id: 'personal', label: 'Personal', icon: '🏠' },
  { id: 'health', label: 'Health', icon: '💪' },
  { id: 'learning', label: 'Learning', icon: '📚' },
  { id: 'creative', label: 'Creative', icon: '🎨' },
  { id: 'social', label: 'Social', icon: '👥' },
  { id: 'finance', label: 'Finance', icon: '💰' },
  { id: 'other', label: 'Other', icon: '📦' }
] as const

// Navigation items
export const NAV_ITEMS = [
  { path: '/', label: 'Home', icon: 'Home' },
  { path: '/quests', label: 'Quests', icon: 'ScrollText' },
  { path: '/gacha', label: 'Gacha', icon: 'Sparkles' },
  { path: '/closet', label: 'Closet', icon: 'Shirt' },
  { path: '/stats', label: 'Stats', icon: 'BarChart3' }
] as const

// Character dialogue
export const CHARACTER_DIALOGUES = {
  hana: {
    idle: [
      "Come on, let's crush some quests today~!",
      "I believe in you! You've got this!",
      "Ready to be productive? Let's go~!"
    ],
    taskComplete: [
      "Kyaa~! You did it! Amazing!",
      "Woohoo! That's my champion!",
      "Yes yes yes! Keep it up~!"
    ],
    streak: [
      "We're on fire! Don't stop now~!",
      "Look at that streak! You're incredible!",
      "I'm so proud of you~!"
    ]
  },
  yuki: {
    idle: [
      "...Another task? Fine. I'll be watching.",
      "Don't waste my time. Get to work.",
      "Hmph. Show me what you can do."
    ],
    taskComplete: [
      "Hmph. Not bad... I suppose.",
      "...Acceptable. Continue.",
      "You're... actually impressive."
    ],
    streak: [
      "You're... consistent. I'll give you that.",
      "Don't let it go to your head.",
      "...I'm mildly impressed."
    ]
  },
  momo: {
    idle: [
      "U-um... I believe in you...",
      "Y-you can do it... I know you can...",
      "I-I'll be cheering for you..."
    ],
    taskComplete: [
      "Y-you did it! *blush* I'm so happy...",
      "A-amazing... you're so cool...",
      "W-wow... *fidgets* Great job..."
    ],
    streak: [
      "W-wow... you're amazing... *blush*",
      "I-I knew you could do it...",
      "S-so impressive... *hides face*"
    ]
  },
  sumire: {
    idle: [
      "Ara ara~ Ready to be productive, dear?",
      "Mommy's here to help you focus~",
      "Come now, sweetie. Let's get some work done~"
    ],
    taskComplete: [
      "Ara~ Such a good child! Mommy is proud~",
      "Fufu~ I knew you could do it, dear~",
      "Well done, sweetie~ Come get your reward~"
    ],
    streak: [
      "My my~ You're on quite a roll, aren't you~",
      "Ara ara~ Mommy is so impressed~",
      "Such dedication~ Mommy loves that about you~"
    ]
  }
} as const
